/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BackToParentButton = function () {
  function BackToParentButton() {
    _classCallCheck(this, BackToParentButton);
    this.backToParentButtons = document.querySelectorAll('.back-to-parent-button');
    this.splitUrlArray = window.location.pathname.split('/');
    this.fullParentPath = "".concat(window.location.origin).concat(this.getParentPath(1));
  }
  return _createClass(BackToParentButton, [{
    key: "getParentPath",
    value: function getParentPath(startIndex) {
      var _this = this;
      var completeParentPath = '';
      this.splitUrlArray.forEach(function (split, index) {
        if (index >= startIndex && index < _this.splitUrlArray.length - 1) {
          completeParentPath = completeParentPath.concat('/', split);
        }
      });
      return completeParentPath;
    }
  }, {
    key: "getJsonApiData",
    value: function getJsonApiData(jsonApiUrl) {
      var _this2 = this;
      fetch(jsonApiUrl).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this2.setBackToParentButtonDetails(data.data.attributes);
      }).catch(function () {});
    }
  }, {
    key: "setBackToParentButtonDetails",
    value: function setBackToParentButtonDetails(parentAttributes) {
      var _this3 = this;
      var _ref = parentAttributes || {},
        _ref$field_title = _ref.field_title,
        fieldTitle = _ref$field_title === void 0 ? '' : _ref$field_title,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '' : _ref$title,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? '' : _ref$name;
      var parentPageName = fieldTitle || title || name || '';
      this.backToParentButtons.forEach(function (button) {
        button.querySelector('.parent-page-name').textContent = parentPageName;
        button.children[0].href = _this3.fullParentPath;
      });
    }
  }, {
    key: "getJsonApiUrlFromAlias",
    value: function getJsonApiUrlFromAlias() {
      var _this4 = this;
      if (window.location.pathname && this.backToParentButtons) {
        var parentPath;
        if (this.splitUrlArray.length > 3) {
          parentPath = this.getParentPath(2);
        } else {
          parentPath = '/';
        }
        fetch("/".concat(window.location.pathname.split('/')[1], "/router/translate-path?path=").concat(parentPath, "&_format=json")).then(function (response) {
          return response.json();
        }).then(function (data) {
          var individual = new URL(data.jsonapi.individual);
          _this4.getJsonApiData(BackToParentButton.getJsonApiUrlWithLanguage(individual.pathname + individual.search));
        }).catch(function () {});
      }
    }
  }], [{
    key: "getJsonApiUrlWithLanguage",
    value: function getJsonApiUrlWithLanguage(jsonApiUrl) {
      if (window.location.pathname.split('/')[1].includes('es')) {
        return jsonApiUrl.replace('/en/', '/es/');
      }
      return jsonApiUrl;
    }
  }]);
}();
export { BackToParentButton as default };
(function () {
  var backToParentButton = new BackToParentButton();
  backToParentButton.getJsonApiUrlFromAlias();
})(Drupal);